export const AD_SPEND_MIN_PERCENT_THRESHOLD = 0.05;

export const CONVERSION_RATE_CHANGE_MAX_CAP_PERCENT = 500;
